import {
  Dialog,
  DialogTitle,
  List,
  Button,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles({
  dialog: {
    "& > div > div": {
      maxHeight: "65%",
    },
  },
  list: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "20px",
  },
  btn: {
    margin: "5px 20px",
    textTransform: "none",
    fontWeight: "400",
    minHeight: "max-content",
  },
  title: {
    textAlign: "center",
    paddingBottom: "0px",
  },
});

const MunicipioDialog = ({ open, setOpen, setSelected, data }) => {
  const classes = useStyles();

  const handleDismiss = () => {
    setOpen(false);
  };

  const handleSubmit = (name) => {
    setSelected(name);
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleDismiss} className={classes.dialog}>
      <DialogTitle className={classes.title}>Ciudad</DialogTitle>
      <List className={classes.list}>
        {data.map((item, idx) => (
          <Button
            className={classes.btn}
            variant="contained"
            color="primary"
            key={idx}
            onClick={() => {
              handleSubmit(item);
            }}
          >
            {item}
          </Button>
        ))}
      </List>
    </Dialog>
  );
};

export default MunicipioDialog;
